// src/pages/jobs/ManageJobEdit.js
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useGlobal } from '../../context/GlobalContext'
import api from '../../services/api'

function toBerlinLocalString(utcString) {
  console.log('[toBerlinLocalString] Input UTC:', utcString)
  if (!utcString) {
    console.log('[toBerlinLocalString] Empty, returning blank.')
    return ''
  }
  const utcDate = new Date(utcString)
  console.log('[toBerlinLocalString] UTC date object:', utcDate)
  const berlinString = utcDate.toLocaleString('en-US', { timeZone: 'Europe/Berlin' })
  console.log('[toBerlinLocalString] Berlin string:', berlinString)
  const berlinDate = new Date(berlinString)
  console.log('[toBerlinLocalString] Berlin date object:', berlinDate)
  const y = berlinDate.getFullYear()
  const m = String(berlinDate.getMonth() + 1).padStart(2, '0')
  const d = String(berlinDate.getDate()).padStart(2, '0')
  const hh = String(berlinDate.getHours()).padStart(2, '0')
  const mm = String(berlinDate.getMinutes()).padStart(2, '0')
  const finalString = `${y}-${m}-${d}T${hh}:${mm}`
  console.log('[toBerlinLocalString] Final:', finalString)
  return finalString
}

function ManageJobEdit() {
  console.log('[ManageJobEdit] Rendering component.')
  const { jobId } = useParams()
  console.log('[ManageJobEdit] jobId:', jobId)
  const { showLoading, hideLoading, showMessage } = useGlobal()
  const navigate = useNavigate()
  const [plainTitle, setPlainTitle] = useState('')
  const [plainDescription, setPlainDescription] = useState('')
  const [assignedTrucker, setAssignedTrucker] = useState('')
  const [site, setSite] = useState('')
  const [steps, setSteps] = useState([])
  const [truckers, setTruckers] = useState([])
  const [sites, setSites] = useState([])
  const [locations, setLocations] = useState([])
  const [filteredLocations, setFilteredLocations] = useState([])

  async function loadJobData() {
    console.log('[ManageJobEdit] loadJobData called.')
    showLoading()
    try {
      const res = await api.get(`/manage-jobs/${jobId}`)
      console.log('[ManageJobEdit] Job data response:', res.data)
      if (res.data && res.data.job) {
        setPlainTitle(res.data.job.plainTitle || '')
        setPlainDescription(res.data.job.plainDescription || '')
        setAssignedTrucker(res.data.job.assignedTrucker?._id || '')
        setSite(res.data.job.site?._id || '')
        if (Array.isArray(res.data.job.steps)) {
          const mapped = res.data.job.steps.map((s) => {
            console.log('[ManageJobEdit] Step from DB:', s)
            const localDueTime = s.dueTime ? toBerlinLocalString(s.dueTime) : ''
            console.log('[ManageJobEdit] Converted to Berlin time:', localDueTime)
            return {
              locationId: s.location?._id || '',
              dueTime: localDueTime,
              reminderBefore: s.reminderBefore || 30,
              reminderInterval: s.reminderInterval || 15,
              message: s.message || '',
              isActive: s.isActive || false
            }
          })
          setSteps(mapped)
        }
      }
    } catch (error) {
      console.error('[ManageJobEdit] Error loading job data:', error)
      showMessage('Error loading job details', 'error')
    } finally {
      hideLoading()
    }
  }

  async function loadAllData() {
    console.log('[ManageJobEdit] loadAllData called.')
    showLoading()
    try {
      const tRes = await api.get('/trucker/company-truckers')
      console.log('[ManageJobEdit] Truckers response:', tRes.data)
      if (tRes.data && tRes.data.truckers) setTruckers(tRes.data.truckers)
      const sRes = await api.get('/site/all')
      console.log('[ManageJobEdit] Sites response:', sRes.data)
      if (sRes.data && sRes.data.sites) setSites(sRes.data.sites)
      const lRes = await api.get('/location/company-locations')
      console.log('[ManageJobEdit] Locations response:', lRes.data)
      if (lRes.data && lRes.data.locations) setLocations(lRes.data.locations)
    } catch (error) {
      console.error('[ManageJobEdit] Error loading data:', error)
      showMessage('Error loading data', 'error')
    } finally {
      hideLoading()
    }
  }

  useEffect(() => {
    console.log('[ManageJobEdit] useEffect - loading all data.')
    loadAllData()
  }, [])

  useEffect(() => {
    console.log('[ManageJobEdit] useEffect - loading job data.')
    loadJobData()
  }, [])

  useEffect(() => {
    console.log('[ManageJobEdit] Filtering locations by site:', site)
    const filtered = locations.filter((r) => r.site && r.site._id === site)
    console.log('[ManageJobEdit] Filtered locations:', filtered)
    setFilteredLocations(filtered)
  }, [site, locations])

  function handleSiteChange(e) {
    console.log('[ManageJobEdit] Site changed:', e.target.value)
    setSite(e.target.value)
  }

  function addStep() {
    console.log('[ManageJobEdit] addStep called.')
    setSteps((prev) => [
      ...prev,
      {
        locationId: '',
        dueTime: '',
        reminderBefore: 30,
        reminderInterval: 15,
        message: '',
        isActive: false
      }
    ])
  }

  function removeStep(index) {
    console.log('[ManageJobEdit] removeStep called. Index:', index)
    setSteps((prev) => prev.filter((_, i) => i !== index))
  }

  function handleStepChange(index, field, value) {
    console.log('[ManageJobEdit] handleStepChange. Index:', index, 'Field:', field, 'Value:', value)
    setSteps((prev) => {
      const updated = [...prev]
      updated[index] = { ...updated[index], [field]: value }
      return updated
    })
  }

  async function handleSubmit(e) {
    e.preventDefault()
    console.log('[ManageJobEdit] handleSubmit called.')
    showLoading()
    try {
      const body = {
        plainTitle,
        plainDescription,
        assignedTrucker,
        site,
        steps: steps.map((s) => ({
          locationId: s.locationId,
          dueTime: s.dueTime || '',
          reminderBefore: s.reminderBefore || 30,
          reminderInterval: s.reminderInterval || 15,
          message: s.message || '',
          isActive: s.isActive || false
        }))
      }
      console.log('[ManageJobEdit] Sending update to API:', body)
      await api.put(`/manage-jobs/${jobId}`, body)
      console.log('[ManageJobEdit] Job updated successfully.')
      showMessage('Job updated successfully', 'success')
      navigate('/manage-jobs')
    } catch (error) {
      console.error('[ManageJobEdit] Error updating job:', error)
      showMessage('Error updating job', 'error')
    } finally {
      hideLoading()
    }
  }

  console.log('[ManageJobEdit] Rendering JSX.')
  return (
    <div style={{ padding: '20px' }}>
      <h2>Edit Job</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '10px' }}>
          <label>Title</label>
          <input
            style={{ marginLeft: '10px' }}
            value={plainTitle}
            onChange={(e) => setPlainTitle(e.target.value)}
            required
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label>Description</label>
          <textarea
            style={{ marginLeft: '10px', verticalAlign: 'top' }}
            value={plainDescription}
            onChange={(e) => setPlainDescription(e.target.value)}
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label>Assign Trucker</label>
          <select
            style={{ marginLeft: '10px' }}
            value={assignedTrucker}
            onChange={(e) => setAssignedTrucker(e.target.value)}
          >
            <option value="">-- Choose --</option>
            {truckers.map((t) => (
              <option key={t._id} value={t._id}>
                {t.plainName} {t.plainSurname} - {t.plainLicensePlateTruck}
              </option>
            ))}
          </select>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label>Select Site</label>
          <select style={{ marginLeft: '10px' }} value={site} onChange={handleSiteChange}>
            <option value="">-- Choose --</option>
            {sites.map((sItem) => (
              <option key={sItem._id} value={sItem._id}>
                {sItem.plainName} - {sItem.address}
              </option>
            ))}
          </select>
        </div>
        <h3>Steps</h3>
        <button type="button" onClick={addStep}>
          Add Step
        </button>
        {steps.map((step, index) => (
          <div
            key={index}
            style={{ border: '1px solid #ccc', padding: '10px', marginTop: '10px' }}
          >
            <label>Step #{index + 1}</label>
            <div style={{ marginTop: '5px' }}>
              <label>Location</label>
              <select
                style={{ marginLeft: '10px' }}
                value={step.locationId}
                onChange={(e) => handleStepChange(index, 'locationId', e.target.value)}
              >
                <option value="">-- Choose --</option>
                {filteredLocations.map((r) => (
                  <option key={r._id} value={r._id}>
                    {r.plainLocationName} ({r.address})
                  </option>
                ))}
              </select>
            </div>
            <div style={{ marginTop: '5px' }}>
              <label>Due Time</label>
              <input
                style={{ marginLeft: '10px' }}
                type="datetime-local"
                value={step.dueTime}
                onChange={(e) => handleStepChange(index, 'dueTime', e.target.value)}
              />
            </div>
            <div style={{ marginTop: '5px' }}>
              <label>Reminder Before (minutes)</label>
              <input
                style={{ marginLeft: '10px' }}
                type="number"
                value={step.reminderBefore}
                onChange={(e) => handleStepChange(index, 'reminderBefore', e.target.value)}
              />
            </div>
            <div style={{ marginTop: '5px' }}>
              <label>Reminder Interval (minutes)</label>
              <input
                style={{ marginLeft: '10px' }}
                type="number"
                value={step.reminderInterval}
                onChange={(e) => handleStepChange(index, 'reminderInterval', e.target.value)}
              />
            </div>
            <div style={{ marginTop: '5px' }}>
              <label>Message</label>
              <input
                style={{ marginLeft: '10px' }}
                value={step.message}
                onChange={(e) => handleStepChange(index, 'message', e.target.value)}
              />
            </div>
            <div style={{ marginTop: '5px' }}>
              <label>Is Active</label>
              <input
                style={{ marginLeft: '10px' }}
                type="checkbox"
                checked={step.isActive}
                onChange={(e) => handleStepChange(index, 'isActive', e.target.checked)}
              />
            </div>
            <button
              type="button"
              style={{ marginTop: '10px' }}
              onClick={() => removeStep(index)}
            >
              Remove Step
            </button>
          </div>
        ))}
        <button type="submit" style={{ marginTop: '20px' }}>
          Update Job
        </button>
      </form>
    </div>
  )
}

export default ManageJobEdit